import React, { useState, useEffect, useRef } from "react";
import { Box, Grid, Menu, IconButton, MenuItem, ListItemIcon } from '@mui/material';
import HeaderSearch from './Search';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import HeaderNotifications from './Notifications';
import { useUserInfo } from 'src/store/user-info-context';
import PersonIcon from '@mui/icons-material/Person';
import Logout from '@mui/icons-material/Logout';
import { useNavigate } from "react-router";

function HeaderButtons() {
  const {user, logout} = useUserInfo();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onlogoutClick = () => {
    logout();
    navigate("/");
  }
  
  return (
    <Box sx={{ mr: 1 }}>
      {/* <HeaderSearch /> */}
      <Box sx={{ mx: 0.5 }} component="span">

        <Grid item>
          <IconButton
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}>
              <Avatar>{user.full_name ? user.full_name.charAt(0).toUpperCase() : ""}</Avatar>
          </IconButton>

          <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem onClick={() => navigate("/account")}>
            <ListItemIcon>
                <PersonIcon fontSize="small" />
            </ListItemIcon>
                My Account
            </MenuItem>

            <MenuItem onClick={onlogoutClick}>
            <ListItemIcon>
                <Logout fontSize="small" />
            </ListItemIcon>
                Logout
            </MenuItem>
          </Menu>

        </Grid> 

      </Box>
    </Box>
  );
}

export default HeaderButtons;
